// extracted by mini-css-extract-plugin
export default {"btn":"LinkButton_btn__1V2aS","arrowicon":"LinkButton_arrowicon__k+IuF","btncontent":"LinkButton_btncontent__5sXL2","btntext":"LinkButton_btntext__hT-d0"};